// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__ToCmg","cell":"ColumnAccessor_cell__2DCdd","firstCellAccent":"ColumnAccessor_firstCellAccent__R_Xqe"};